module.exports = __webpack_public_path__ + "static/grung_green_blahp-6d19d9e0afc5928a42062fa12ed5f78a.jpg";